import React, {useEffect} from 'react';
import BtnPrimary from "../../../../shared/ui/button/primary/BtnPrimary";
import ModalCustom from "../../../../shared/ui/modal/ModalCustom";
import http from "../../../../shared/utils/http";

const ModalDeleteCompanyConfirm = ({confirmHandler, closeHandler, data, msg, step, employees, setEmployees}: any) => {


    useEffect(() => {
        if (step === 0) {
            http.get(`pharmacists/${data?.idPharmacist}/pharmacies/${data?.idDocument}/employees`).then(r => {
                setEmployees(r?.employees)
            })
        }
    }, [step]);


    const confirm = () => {
        if (employees && employees?.length <= 0) {
            confirmHandler('delete')
        } else {
            confirmHandler('next')
        }
    }

    return (
        <ModalCustom title={`Conferma cancellazione azienda? ${step}`} closeModal={closeHandler}
                     footerTemplate={<div className={'btn-row'}>
                         <BtnPrimary onClick={closeHandler}
                                     variant={'outline-primary'}
                                     className={'text-primary'}>Annulla</BtnPrimary>
                         <BtnPrimary onClick={confirm}>Si, confermo</BtnPrimary>
                     </div>}>
            <p>{msg}</p>
            {employees && employees.length > 0 && step === 1 && <div>
                <p>Lista dipendenti presenti in azienda e che verranno eliminati</p>
                <ul>
                    {employees?.map((ele: any) => (
                        <li>{ele.name} {ele.surname} | {ele.email}</li>
                    ))}
                </ul>
            </div>}
        </ModalCustom>
    );
};

export default ModalDeleteCompanyConfirm;
